import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import {
    ProjectModel,
    ProjectModelPagedResponseModel,
    CreateProjectRequestModel,
    QueryParams,
    ApiResponse
} from '../models';

/**
 * Projects API Service
 */
@Injectable({
    providedIn: 'root'
})
export class ProjectsService extends BaseApiService {

    /**
     * Get all projects with pagination
     */
    getProjects(params?: QueryParams): Observable<ApiResponse<ProjectModelPagedResponseModel>> {
        return this.get<ProjectModelPagedResponseModel>('/projects', params);
    }

    /**
     * Get project by ID
     */
    getProjectById(projectId: string): Observable<ApiResponse<ProjectModel>> {
        return this.get<ProjectModel>(`/projects/${projectId}`);
    }

    /**
     * Create a new project
     */
    createProject(project: CreateProjectRequestModel): Observable<ApiResponse<ProjectModel>> {
        return this.post<ProjectModel>('/projects', project);
    }

    /**
     * Update project name
     */
    updateProjectName(projectId: string, name: string): Observable<ApiResponse<ProjectModel>> {
        return this.put<ProjectModel>(`/projects/${projectId}/name`, { name });
    }

    /**
     * Update project description
     */
    updateProjectDescription(projectId: string, description: string): Observable<ApiResponse<ProjectModel>> {
        return this.put<ProjectModel>(`/projects/${projectId}/description`, { description });
    }

    /**
     * Set project file
     */
    setProjectFile(projectId: string, fileId: string): Observable<ApiResponse<ProjectModel>> {
        return this.put<ProjectModel>(`/projects/${projectId}/project-file`, { fileId });
    }

    /**
     * Activate project
     */
    activateProject(projectId: string): Observable<ApiResponse<ProjectModel>> {
        return this.post<ProjectModel>(`/projects/${projectId}/activate`);
    }

    /**
     * Deactivate project
     */
    deactivateProject(projectId: string): Observable<ApiResponse<ProjectModel>> {
        return this.post<ProjectModel>(`/projects/${projectId}/deactivate`);
    }

    /**
     * Archive project
     */
    archiveProject(projectId: string): Observable<ApiResponse<ProjectModel>> {
        return this.post<ProjectModel>(`/projects/${projectId}/archive`);
    }

    /**
     * Get active project
     */
    getActiveProject(): Observable<ApiResponse<ProjectModel>> {
        return this.get<ProjectModel>('/projects/active');
    }

    /**
     * Get projects by directory
     */
    getProjectsByDirectory(directoryName: string): Observable<ApiResponse<ProjectModel[]>> {
        return this.get<ProjectModel[]>(`/projects/by-directory/${directoryName}`);
    }

    /**
     * Get projects by system
     */
    getProjectsBySystem(systemName: string): Observable<ApiResponse<ProjectModel[]>> {
        return this.get<ProjectModel[]>(`/projects/systems/${systemName}/projects`);
    }
}



